import { render, staticRenderFns } from "./TextCell.vue?vue&type=template&id=8dfb003e&scoped=true&"
import script from "./TextCell.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TextCell.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TextCell.vue?vue&type=style&index=0&id=8dfb003e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfb003e",
  null
  
)

export default component.exports